import { FC, useState } from 'react';
import { isIE } from 'react-device-detect';

import { getOptOutModernBrowserCookie, setOptOutModernBrowserCookie } from 'app/api/cookie';
import Drawer from 'app/components/v2/components/Drawer';

import ModernBrowserPromptUI from './ModernBrowserPromptUI';

// Component Definition
const ModernBrowserInterstitial: FC = () => {
  const [optOutCookie, setOptOutCookie] = useState(getOptOutModernBrowserCookie());

  function handleClickReject() {
    setOptOutModernBrowserCookie();
    setOptOutCookie(getOptOutModernBrowserCookie());
  }

  if (!isIE) {
    return null;
  }

  return (
    <Drawer
      isOpen={optOutCookie !== 'true'}
      position="bottom"
    >
      <ModernBrowserPromptUI
        onClickReject={handleClickReject}
      />
    </Drawer>
  );
};

export default ModernBrowserInterstitial;
